import { Box, Link, Stack } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faTags } from "@fortawesome/pro-duotone-svg-icons";
import NextLink from "next/link";
import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";

const SEARCH_URL = 'https://repository.brieflands.com/search?query=';

const Keywords = ({ keywords = [] }: { keywords?: string[] }) => (
    <Box color={"text.primary"}>
        <Stack direction="row" alignItems="center" gap={.25}>
            <SpanTypography color="custom.brown" fontSize={'1.5rem'}>
                <FontAwesomeIcon
                    icon={faTags}
                />
            </SpanTypography>
            <SpanTypography
                variant="h4"
                fontSize={'1.5rem'}
                color="primary.main"
            >
                Keywords
            </SpanTypography>
        </Stack>
        <Stack
            direction="row"
            flexWrap="wrap"
            gap={.5}
            pt={.5}
        >
            {
                keywords.map((
                    keyword: string,
                    index: number
                ) =>
                    ( keyword && keyword !== '' ) &&
                    <Link
                        key={`keyword-${index}`}
                        component={NextLink}
                        target="_blank"
                        href={`${SEARCH_URL}${encodeURIComponent(keyword.trim())}`}
                        sx={{
                            '&:hover': {
                                '& > div': {
                                    '& > span:nth-of-type(2)': {
                                        color: 'custom.brown'
                                    }
                                }
                            }
                        }}
                    >
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"center"}
                            bgcolor={"secondary.main"}
                            sx={{
                                padding: '.2rem .5rem',
                                borderRadius: '.3rem'
                            }}
                        >
                            <SpanTypography
                                mr={.25}
                                fontSize={6}
                                color={"custom.darkBrown"}
                            >
                                <FontAwesomeIcon
                                    icon={faCircle}
                                />
                            </SpanTypography>
                            <SpanTypography
                                p={0}
                                component={"span"}
                                fontSize={'.8rem'}
                                fontWeight={"bold"}
                                color={"custom.darkBrown"}
                            >
                                {
                                    ReactHtmlParser(keyword.trim())
                                }
                            </SpanTypography>
                        </Box>
                    </Link>
                )
            }
        </Stack>
    </Box>
)

export default Keywords;